// Function to handle token expiration by logging out the user
export const handleTokenExpiration = () => {
    // Clear all auth data
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Force reload to clear all states
    window.location.href = '/login';
};

// Check if an error is due to token expiration
export const isTokenExpired = (error) => {
    return error?.code === 'TOKEN_EXPIRED' || 
           error?.message?.toLowerCase().includes('expired') ||
           error?.response?.status === 401;
};

// Create headers with Authorization token if available
export const createAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
    };
};

// Parse JWT token to get expiration time
export const getTokenExpiration = (token) => {
    if (!token) return null;
    
    try {
        // Split the token and get the payload (second part)
        const payload = token.split('.')[1];
        // Base64 decode and parse as JSON
        const decoded = JSON.parse(atob(payload));
        
        // The 'exp' claim contains the expiration timestamp in seconds
        if (decoded.exp) {
            // Convert to milliseconds for JavaScript Date
            return new Date(decoded.exp * 1000);
        }
    } catch (error) {
        console.error('Error parsing token:', error);
    }
    
    return null;
};

// Check if token is expired or about to expire
export const isTokenValid = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    
    const expiration = getTokenExpiration(token);
    if (!expiration) return false;
    
    // Token is valid if it's not expired
    return expiration > new Date();
};

// Calculate time remaining before token expires (in milliseconds)
export const getTokenTimeRemaining = () => {
    const token = localStorage.getItem('token');
    if (!token) return 0;
    
    const expiration = getTokenExpiration(token);
    if (!expiration) return 0;
    
    const now = new Date();
    const remaining = expiration - now;
    
    return remaining > 0 ? remaining : 0;
}; 